import React from "react";

const Address = () => {
  return (
    <>
    <ul className="wrapper" style={{width:'100%'}}>
      <li data-aos="fade-right" data-aos-duration="1200" data-aos-delay="100" style={{width:'100%'}}>
        <div className="list_inner" style={{padding:'15px', width:'100%'}}>
          <div className="icon">
            <img src="img/address/email.png" alt="icon" />
          </div>
          {/* End icon */}
          <div className="content">
            <h3>Email</h3>
            <ul>
              <li>
                <a href="mailto:m.macrino@avvocatomacrino.it">m.macrino@avvocatomacrino.it</a>
              </li>
              <li>
                <a href="mailto:maria.macrino@ordineavvocaticuneo.eu">maria.macrino@ordineavvocaticuneo.eu </a>
              </li>
            </ul>
          </div>{" "}
          {/* End .content */}
        </div>
      </li>
      </ul>
    <ul className="wrapper">
      <li data-aos="fade-right" data-aos-duration="1200">
        <div className="list_inner" style={{padding:'15px'}}>
          <div className="icon">
            <img src="img/address/phone.png" alt="icon" />
          </div>
          {/* End icon */}
          <div className="content">
            <h3>Telefono</h3>
            <ul>
              <li>
                <a href="Tel: +39 3386538579">338.6538579</a>
              </li>
              <li>
                <a style={{visibility:'hidden'}}>.</a>
              </li>
            </ul>
          </div>{" "}
          {/* End .content */}
        </div>
      </li>
      <li data-aos="fade-right" data-aos-duration="1200" data-aos-delay="200">
        <div className="list_inner" style={{padding:'15px'}}>
          <div className="icon">
            <img src="img/address/location.png" alt="icon" />
          </div>
          {/* End icon */}
          <div className="content">
            <h3>Indirizzo</h3>
            <ul>
              <li>
                <p>
                  Via Asilo n. 23
                  <br />
                  Farigliano (CN) – 12060
                </p>
              </li>
            </ul>
          </div>
          {/* End .content */}
        </div>
      </li>
    </ul>
    </>
  );
};

export default Address;
